import React from "react";

const Arrow = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" className={"arr " + props.style}  onClick={props.click} xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5626 16L10.9626 9.39998L12.8479 7.51465L21.3333 16L12.8479 24.4853L10.9626 22.6L17.5626 16Z" />
    </svg>
  );
};
export default Arrow;
